import React from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {getCustomers} from '../core/_requests'
import {usersColumns} from './columns/_columns'
import {FilterForm, initialFilters} from './components/FilterForm'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard'
}])

const ListWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>Customers list</PageTitle>
      <TableWrapper
        dataProvider={getCustomers}
        cols={usersColumns}
        queryId="CUSTOMERS_LIST"
        lookup={{
          placeholder: 'Search Customer',
          fields: ['Email', 'Username', 'Msisdn']
        }}
        filters={{
          formFields: FilterForm,
          initialValues: initialFilters
        }}
      />
    </>
  )
}

export default ListWrapper
